import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';

const SsoCallback = () => {
  const navigate = useNavigate();
  const { checkUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorParam = params.get('error');
    const errorDescription = params.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      return;
    }

    if (!code) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const response = await authService.exchangeSsoCode(code);
        localStorage.setItem('idToken', response.idToken);
        localStorage.setItem('accessToken', response.accessToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        await checkUser();
        navigate('/dashboard', { replace: true });
      } catch (err) {
        setError(err.message || 'SSO login failed');
      }
    })();
  }, []);

  if (error) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h1>Sign In Failed</h1>
          <p className="subtitle">{error}</p>
          <button className="btn btn-primary btn-full" onClick={() => navigate('/login', { replace: true })}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <p className="subtitle">Signing you in...</p>
      </div>
    </div>
  );
};

export default SsoCallback;
